module.exports = __webpack_public_path__ + "img/bctech_iphonexspacegrey_portrait.2bc6c054.png";